import { getHyperfindLabel } from '../../utils';

/**
 * @param { ApiAdmin.IHyperfindQuery[] } hyperfinds
*/
export const transformToArchiveModel = (hyperfinds) => (x) => (
    {
        ...x,
        creationHyperfindName: getHyperfindLabel(x.creationHyperfindId, hyperfinds),
        managementHyperfindName: getHyperfindLabel(x.managementHyperfindId, hyperfinds)
    });